import type { OrderListItemDTO } from '@wf/shared'

/**
 * Volltext-Treffer über die Felder, die real auf der Karte stehen: Nummer, Notiz, Kennzeichen, Fahrzeug,
 * Kunde. `q` ist bereits klein und getrimmt. Die denormalisierten Anzeigefelder kommen jetzt direkt aus
 * dem Listen-DTO (OrderListItemDTO) — die Suche prüft also genau das, was die Karte zeigt.
 */
export function orderMatchesText(order: OrderListItemDTO, q: string): boolean {
  return (
    (order.nr ?? '').toLowerCase().includes(q) ||
    (order.note ?? '').toLowerCase().includes(q) ||
    (order.plate ?? '').toLowerCase().includes(q) ||
    (order.vehicleModel ?? '').toLowerCase().includes(q) ||
    (order.customerName ?? '').toLowerCase().includes(q)
  )
}
